import GallerySection from './GallerySection';

export default GallerySection;
